import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Table, TableHead, TableBody, TableRow, TableCell } from "@material-ui/core";
import { FormattedNumber, useIntl } from "react-intl";
import { messages } from "../../messages";
function formatNumber(value) {
    return (_jsx(FormattedNumber, { value: value, minimumFractionDigits: 2, maximumFractionDigits: 2, children: (formatted) => formatted.endsWith(",00") ? formatted.replace(",00", ",-") : formatted }));
}
function formatPaymentInterval(value, intl) {
    switch (value) {
        case 1:
            return intl.formatMessage(messages.monthly);
        case 3:
            return intl.formatMessage(messages.quarterly);
        case 6:
            return intl.formatMessage(messages.semiannually);
        case 12:
            return intl.formatMessage(messages.annually);
        default:
            return "-";
    }
}
const DetailsTable = ({ application, classes }) => {
    const intl = useIntl();
    const columns = [
        {
            label: "originalPrice",
            value: formatNumber(application?.OriginalPrice)
        },
        {
            label: application?.ContactRoleCode === "Lev" ? "rentAmount" : "residualValue",
            value: application?.ContactRoleCode === "Lev"
                ? formatNumber(application?.NextTermAmount)
                : formatNumber(application?.GuaranteedResidualValue)
        },
        {
            label: "paymentInterval",
            value: formatPaymentInterval(application?.CurrentTermLength, intl)
        },
        {
            label: "duration",
            value: application?.TotalTerms || "-"
        },
        {
            label: "startDate",
            value: application?.StartDate || "-"
        },
        {
            label: "endDate",
            value: application?.EndDate || "-"
        }
    ];
    return (_jsxs(Box, { className: classes.card, children: [_jsx(Typography, { className: classes.sectionTitle, children: intl.formatMessage(messages.details) }), _jsxs(Table, { className: classes.desktopDetails, children: [_jsx(TableHead, { children: _jsx(TableRow, { children: columns
                                .filter(col => !col.hidden)
                                .map(col => (_jsx(TableCell, { style: { minWidth: 100 }, children: _jsx(Typography, { variant: "subtitle2", children: intl.formatMessage(messages[col.label]) }) }, col.label))) }) }), _jsx(TableBody, { className: classes.tableBody, children: _jsx(TableRow, { children: columns
                                .filter(col => !col.hidden)
                                .map(col => (_jsx(TableCell, { style: { minWidth: 100 }, children: _jsx(Typography, { variant: "body2", children: col.value }) }, col.label))) }) })] }), _jsx(Box, { className: classes.mobileDetails, children: columns
                    .filter(col => !col.hidden)
                    .map(col => (_jsxs(Box, { children: [_jsx(Typography, { variant: "subtitle2", children: intl.formatMessage(messages[col.label]) }), _jsx(Typography, { variant: "body2", children: col.value })] }, col.label))) })] }));
};
export default DetailsTable;
//# sourceMappingURL=DetailsTable.js.map